import BaseStore from '@/store/baseStore'
import api from '../api/api'

export const namespaced = true

const baseURI = '/project_user/'

const baseStore = new BaseStore(baseURI)

const getDefaultState = () => ({
  ...structuredClone(baseStore.state),
  isSearching: false,
  searchResults: []
})

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  SET_SEARCH_RESULTS(state, users = []) {
    state.searchResults = users
  },
  SET_IS_SEARCHING(state, isSearching) {
    state.isSearching = isSearching
  }
}

export const actions = {
  ...baseStore.actions,
  async searchUsers({ commit }, { projectId, email }) {
    commit('SET_IS_SEARCHING', true)
    const searchParams = new URLSearchParams({ project_id: projectId, email }).toString()
    const url = `/users/?${searchParams}`
    const { data } = await api.get(url)
    commit('SET_SEARCH_RESULTS', data.results)
    commit('SET_IS_SEARCHING', false)
  },
  async addUsers(
    store,
    {
      userIds,
      projectId,
      selected_year,
      selected_soil_type_revision,
      selected_stage_configuration_revision,
      selected_water_line_rule_revision,
      selected_bursting_parameter_revision
    }
  ) {
    await api.post(
      baseURI,
      userIds.map((id) => ({
        user: id,
        project: projectId,
        selected_year,
        selected_soil_type_revision,
        selected_stage_configuration_revision,
        selected_water_line_rule_revision,
        selected_bursting_parameter_revision
      }))
    )
  },
  async updateRoles(store, items = []) {
    await api.patch(`${baseURI}bulk_update/`, items)
  },
  resetState({ commit }) {
    commit('RESET_STATE')
  }
}

export const getters = {
  getSearchItems(state) {
    return state.searchResults.map((result) => ({
      text: result.email,
      value: result.id
    }))
  }
}
